import Vue from 'vue'

Vue.component('v-panel', () => import('./Panel.vue'))